module.exports = __webpack_public_path__ + "img/stock6.2420fb9a.png";